export default {
    "MIME-Version": "1.0",
    "Content-Type": "text/plain; charset=utf-8",
    "Content-Transfer-Encoding": "8bit",
    "X-Generator": "Ideo Core",
    "PO-Revision-Date": "2025-01-16T18:28:34.737Z",
    "Last-Translator": "",
    "Language-Team": "",
    "Language": "en-US",
    "Messages": {
        "Absolutne": "Absolute",
        "Adres": "Address",
        "Adres email": "Email address",
        "Ai": "AI",
        "Akcje warstwy": "Layer actions",
        "Akcje widgetu": "Widget actions",
        "Aktualna karta": "Current tab",
        "Aktualne selektory dla których wyświetlane i edytowane są style": "Current selectors for which styles are displayed and edited",
        "Aktywne": "Active",
        "Angielski": "English",
        "Animacja elementu": "Element animation",
        "Animacje": "Animations",
        "Anuluj": "Cancel",
        "Arkusz styli": "Stylesheet",
        "Arkusze styli": "Stylesheets",
        "Auto": "Auto",
        "Automatyczna": "Automatic",
        "Automatyczne odtwarzanie": "Autoplay",
        "Bez limitu": "Unlimited",
        "Biblioteka": "Library",
        "Błąd podczas dodawania urządzenia": "Error adding device",
        "Błędna szerokość": "Invalid width",
        "Blur": "Blur",
        "brak": "none",
        "Brak": "None",
        "Brak animacji": "No animation",
        "Brak elementów pasujących do wyszukiwania.": "No items match your search.",
        "Brak limitu": "No limit",
        "Brak szablonów.": "No templates.",
        "Brak widgetów pasujących do wyszukiwania.": "No widgets match your search.",
        "Brak zawartości strony": "No page content",
        "Cały tekst małą literą": "Lowercase",
        "Cały tekst wielką literą": "Uppercase",
        "Checkbox": "Checkbox",
        "Cień": "Shadow",
        "Cofnij": "Undo",
        "CSS": "CSS",
        "Cytat": "Quote",
        "Czas trwania": "Duration",
        "Czas trwania (ms)": "Duration (ms)",
        "Czas trwania zmiany styli (transition)": "Style transition duration",
        "Czcionka": "Font",
        "Czcionki": "Fonts",
        "Czy na pewno chcesz usunąć to urządzenie?": "Are you sure you want to delete this device?",
        "Dekoracja": "Decoration",
        "Do lewej": "Left",
        "Do prawej": "Right",
        "Dodaj": "Add",
        "Dodaj element": "Add element",
        "Dodaj klasę": "Add class",
        "Dodaj kolejną klasę": "Add another class",
        "Dodaj kolejną opcję": "Add another option",
        "Dodaj kolejny arkusz styli": "Add another stylesheet",
        "Dodaj kolejny skrypt": "Add another script",
        "Dodaj kolor": "Add color",
        "Dodaj niestandardowe urządzenie": "Add custom device",
        "Dodaj nowy element listy": "Add new list item",
        "Dodaj nowy slajd": "Add new slide",
        "Dodaj szablon": "Add template",
        "Dodaj warstwę": "Add layer",
        "Dodatkowy element": "Additional element",
        "Dolny": "Bottom",
        "Domyślny": "Default",
        "Dostępne klasy": "Available classes",
        "Duplikuj": "Duplicate",
        "Duży komputer": "Large desktop",
        "Duży telefon": "Large phone",
        "Dwie kolumny w wierszu": "Two columns in a row",
        "Dziedziczona": "Inherited",
        "ease": "ease",
        "ease-in": "ease-in",
        "ease-in-out": "ease-in-out",
        "ease-out": "ease-out",
        "Edycja": "Edit",
        "Edytor kodu CSS": "CSS code editor",
        "Edytor kodu HTML": "HTML code editor",
        "Edytor kodu JavaScript": "JavaScript code editor",
        "Edytor kodu Vue": "Vue code editor",
        "Edytor komponentu React": "React component editor",
        "Edytuj": "Edit",
        "Edytuj kod CSS": "Edit CSS code",
        "Edytuj kod HTML": "Edit HTML code",
        "Edytuj kod JavaScript": "Edit JavaScript code",
        "Edytuj kod Vue": "Edit Vue code",
        "Edytuj komponent React": "Edit React component",
        "Edytuj style": "Edit styles",
        "Edytuj szablon": "Edit template",
        "Efekty": "Effects",
        "Eksportuj stronę": "Export page",
        "Eksportuj widget": "Export widget",
        "Element {name}": "Element {name}",
        "Element klikalny": "Clickable element",
        "Element listy": "List item",
        "Elementy": "Elements",
        "Etykieta": "Label",
        "Film": "Video",
        "Film YouTube": "YouTube video",
        "Filtr": "Filter",
        "Filtr tła": "Background filter",
        "Flex": "Flex",
        "Formularz": "Form",
        "Francuski": "French",
        "Funkcja": "Function",
        "Generuj tekst": "Generate text",
        "Globalna klasa": "Global class",
        "Globalne kolory": "Global colors",
        "Górny": "Top",
        "Gradient": "Gradient",
        "Gradient promieniowy": "Radial gradient",
        "Grid": "Grid",
        "Gruba": "Bold",
        "Grubość obramowania": "Border width",
        "Grubość tekstu": "Text weight",
        "Historia edycji": "Edit history",
        "Hover": "Hover",
        "Id inputa": "Input ID",
        "Ikona": "Icon",
        "Importuj stronę": "Import page",
        "Importuj widget": "Import widget",
        "Indeksowanie": "Indexing",
        "Indeksuj": "Index",
        "Indykatory": "Indicators",
        "Indykatory poza sliderem": "Indicators outside slider",
        "Italic": "Italic",
        "Jasność": "Brightness",
        "Jedna wartość": "Single value",
        "Jednostka": "Unit",
        "Język": "Language",
        "Klasy": "Classes",
        "Kod": "Code",
        "Kod nie może być pusty": "Code cannot be empty",
        "Kod skopiowany.": "Code copied.",
        "Kod strony": "Page code",
        "Kod svg": "SVG code",
        "Koło": "Circle",
        "Kolor": "Color",
        "Kolor obramowania": "Border color",
        "Kolor strzałek": "Arrow color",
        "Kolor tekstu": "Text color",
        "Kolor wypełnienia indykatorów": "Indicator fill color",
        "Kolory": "Colors",
        "Kolumna": "Column",
        "Kolumny": "Columns",
        "Komputer": "Computer",
        "Konfiguracja": "Configuration",
        "Kontener": "Container",
        "Kontrast": "Contrast",
        "Kontrolki playera": "Player controls",
        "Kopiuj": "Copy",
        "Kreator stron": "Page builder",
        "Krok": "Step",
        "Kursor": "Cursor",
        "Kwadrat": "Square",
        "Label": "Label",
        "Label dla inputa": "Input label",
        "Laptop": "Laptop",
        "Lepkie": "Sticky",
        "Lewy": "Left",
        "Lewy dolny": "Bottom left",
        "Lewy dolny róg": "Bottom-left corner",
        "Lewy górny": "Top left",
        "Lewy górny róg": "Top-left corner",
        "Liczba widocznych slajdów": "Number of visible slides",
        "Liczby dziesiętne": "Decimal numbers",
        "Liczby rzymskie": "Roman numerals",
        "linear": "linear",
        "Linia ciągła": "Solid line",
        "Linia kropkowana": "Dotted line",
        "Linia u dołu tekstu": "Line below text",
        "Linia u góry tekstu": "Line above text",
        "Linia wycentrowana": "Centered line",
        "Link": "Link",
        "Link do filmu YouTube": "YouTube video link",
        "LinkBox": "LinkBox",
        "Lista": "List",
        "Lista nienumerowana": "Unordered list",
        "Lista numerowana": "Numbered list",
        "Maks. szerokość": "Max. width",
        "Maks. wysokość": "Max. height",
        "Maksymalna szerokość": "Maximum width",
        "Maksymalna szerokość w px": "Maximum width in px",
        "Mały tablet": "Small tablet",
        "Mały telefon": "Small phone",
        "Mapa": "Map",
        "Margines": "Margin",
        "Menadżer urządzeń": "Device manager",
        "Metoda": "Method",
        "Min. szerokość": "Min. width",
        "Min. wysokość": "Min. height",
        "Motywy": "Themes",
        "Nagłówek": "Heading",
        "Nagłówek 1": "Heading 1",
        "Nagłówek 2": "Heading 2",
        "Nagłówek 3": "Heading 3",
        "Nagłówek 4": "Heading 4",
        "Nagłówek 5": "Heading 5",
        "Narzędzia AI": "AI tools",
        "Narzędzia kreatora": "Builder tools",
        "Narzędzia strony": "Page tools",
        "Następny slajd": "Next slide",
        "Nawigacja": "Navigation",
        "Nazwa": "Name",
        "Nazwa klasy": "Class name",
        "Nazwa koloru": "Color name",
        "Nazwa koloru jest wymagana": "Color name is required",
        "Nazwa koloru już istnieje": "Color name already exists",
        "Nazwa musi mieć minimum 2 znaki": "Name must be at least 2 characters",
        "Nazwa nie może być pusta": "Name cannot be empty",
        "Nazwa skryptu": "Script name",
        "Nazwa szablonu": "Template name",
        "Nazwa urządzenia": "Device name",
        "Nazwa warstwy": "Layer name",
        "Nie indeksuj": "Do not index",
        "Nie posiadasz uprawnień aby zaimportować komponent": "You do not have privileges to import the component",
        "Nie posiadasz uprawnień aby zapisać komponent": "You do not have privileges to save the component",
        "Nie posiadasz uprawnień do dodania nowego motywu": "You do not have privileges to add a new theme",
        "Nie posiadasz uprawnień do edycji zapisanego komponentu": "You do not have privileges to edit the saved component",
        "Nie posiadasz uprawnień do usunięcia motywu": "You do not have privileges to delete the theme",
        "Nie posiadasz uprawnień do usunięcia zapisanego komponentu": "You do not have privileges to delete the saved component",
        "Nie powtarzaj": "Do not repeat",
        "Nie udało się pobrać definicji widgetu": "Failed to retrieve widget definition",
        "Nie udało się pobrać szablonów": "Failed to retrieve templates",
        "Nie udało się pobrać widgetów": "Failed to retrieve widgets",
        "Nie udało się skopiować kodu.": "Failed to copy code.",
        "Nie udało się usunąć szablonu.": "Failed to delete template.",
        "Nie udało się wczytać widgetu.": "Failed to load widget.",
        "Nie udało się wygenerować tekstu": "Failed to generate text",
        "Nie udało się zaimportować widgetu": "Failed to import widget",
        "Nie udało się zaktualizować widgetu": "Failed to update widget",
        "Nie udało się zapisać widgetu": "Failed to save widget",
        "Nie wyświetlaj": "Do not display",
        "Nie zawijaj": "Do not wrap",
        "Niemiecki": "German",
        "Nienumerowana": "Unordered",
        "Nieparzysty element": "Odd element",
        "Nieprawidłowy format koloru": "Invalid color format",
        "Nieruchome": "Fixed",
        "Niestandardowe": "Custom",
        "Normalna": "Normal",
        "Nowa karta": "New tab",
        "np. checkbox-1": "e.g. checkbox-1",
        "np. https://ideo.pl": "e.g. https://ideo.pl",
        "np. Jan": "e.g. Jan",
        "np. Nad przyrwą 13": "e.g. Nad przyrwą 13",
        "np. radio-1": "e.g. radio-1",
        "np. Tekst opisowy": "e.g. Descriptive text",
        "np. Twoje imie": "e.g. Your name",
        "Numerowana": "Numbered",
        "Obetnij nadmiar": "Truncate",
        "Obramowanie": "Border",
        "Obrót odcieni": "Hue rotation",
        "Odblokuj": "Unlock",
        "Odepnij": "Detach",
        "Odległość między elementami": "Spacing between elements",
        "Odległość między slajdami (px)": "Spacing between slides (px)",
        "Odległość od dolnej krawędzi": "Distance from bottom edge",
        "Odległość od górnej krawędzi": "Distance from top edge",
        "Odległość z lewej strony": "Distance from left",
        "Odległość z prawej strony": "Distance from right",
        "Odstęp dookoła elementów": "Spacing around elements",
        "Odstęp pomiędzy elementami": "Spacing between elements",
        "Odwrócenie": "Reversal",
        "Odziedzoczono po": "Inherited from",
        "Offset x": "Offset x",
        "Offset Y": "Offset Y",
        "Opcje": "Options",
        "Opis dla open graph": "Open Graph description",
        "Opis strony": "Page description",
        "Opóźnienie (ms)": "Delay (ms)",
        "Osobno dla boków": "Separate for each side",
        "Ostatnie kolory": "Recent colors",
        "Otwórz kreator stron": "Open page builder",
        "Padający cień": "Drop shadow",
        "Padding": "Padding",
        "Page builder": "Page builder",
        "Page Builder": "Page Builder",
        "Paragraf": "Paragraph",
        "Parzysty element": "Even element",
        "Pasek progresu": "Progress bar",
        "Podaj szerokość w px": "Enter width in px",
        "Podany kod jest niepoprawny, w konsoli znajdują się informacje o błędach": "The code provided is invalid; error details are available in the console",
        "Podgląd": "Preview",
        "Podkreślenie": "Underline",
        "Podpowiedź": "Tooltip",
        "Pogrubienie": "Bold",
        "Pojedyńcza kolumna": "Single column",
        "Pokaż": "Show",
        "Pokaż etykietę": "Show label",
        "Pokaż więcej": "Show more",
        "Położenie": "Position",
        "Polski": "Polish",
        "Pomniejsz": "Zoom out",
        "Pomoc": "Help",
        "Ponów": "Retry",
        "Poprzedni slajd": "Previous slide",
        "Powiększ": "Zoom in",
        "Powiększenie": "Zoom",
        "Powiększenie kanwy": "Canvas zoom",
        "Powrzarzanie tła": "Background repeat",
        "Powtarzaj": "Repeat",
        "Powtarzaj horyzontalnie": "Repeat horizontally",
        "Powtarzaj wertykalnie": "Repeat vertically",
        "Pozycja": "Position",
        "Pozycja tła": "Background position",
        "Prawy": "Right",
        "Prawy dolny": "Bottom right",
        "Prawy dolny róg": "Bottom right corner",
        "Prawy górny": "Top right",
        "Prawy górny róg": "Top right corner",
        "Prezentacja": "Presentation",
        "Prosty": "Simple",
        "Przeciągnij {name}": "Drag {name}",
        "Przejdź wyżej": "Move up",
        "Przekierowanie": "Redirect",
        "Przekreślenie": "Strikethrough",
        "Przełącz edycję styli klas": "Toggle class style editing",
        "Przełącz obramowanie": "Toggle border",
        "Przełącz rozwinięcie": "Toggle expansion",
        "Przenieś warstwę": "Move layer",
        "Przesunięcie": "Offset",
        "Przesunięcie w dół": "Move down",
        "Przesunięcie w górę": "Move up",
        "Przesunięcie w lewo": "Move left",
        "Przesunięcie w prawo": "Move right",
        "Przeźroczystość": "Opacity",
        "Przycisk": "Button",
        "Przykładowy tekst": "Sample text",
        "Przypnij do lewej krawędzi": "Pin to left edge",
        "Przypnij do prawej krawędzi": "Pin to right edge",
        "Radio": "Radio",
        "React": "React",
        "Relatywne": "Relative",
        "Resetuj wymiary": "Reset dimensions",
        "Równe odstępy": "Equal spacing",
        "Rozbudowany": "Advanced",
        "Rozbuduj tekst": "Expand text",
        "Rozciągnij": "Stretch",
        "Rozmiar": "Size",
        "Rozmiar strzałek": "Arrow size",
        "Rozmiar tekstu": "Text size",
        "Rozmycie": "Blur",
        "Rozstaw liter": "Letter spacing",
        "Saturacja": "Saturation",
        "Schowaj": "Hide",
        "Sekcja": "Section",
        "Selektor kolorów": "Color picker",
        "SEO": "SEO",
        "Separator": "Separator",
        "Sepia": "Sepia",
        "SFC": "SFC",
        "Sformatuj poprawnie nazwę klasy": "Format class name correctly",
        "Skala 100%": "Scale 100%",
        "Skala szarości": "Grayscale",
        "Skrypt": "Script",
        "Skrypt aktywny": "Script active",
        "Skrypty": "Scripts",
        "Slajd": "Slide",
        "Slajder": "Slider",
        "Sposób wprowadzania koloru": "Color input method",
        "Sposób wprowadzania wartości": "Value input method",
        "Spread": "Spread",
        "Środek dolnej krawędzi": "Bottom center",
        "Środek górnej krawędzi": "Top center",
        "Środek kontenera": "Container center",
        "Środek lewej krawędzi": "Left center",
        "Środek prawej krawędzi": "Right center",
        "Stan": "State",
        "Stan elementu": "Element state",
        "Statyczne": "Static",
        "Strona nie ma jeszcze zawartości": "Page has no content yet",
        "Strona zbudowana w Page Builderze": "Page built with Page Builder",
        "Strzałki poza slajderem": "Arrows outside slider",
        "Styl": "Style",
        "Styl obramowania": "Border style",
        "Styl tekstu": "Text style",
        "Style": "Styles",
        "Style nie mogą być puste": "Styles cannot be empty",
        "Style tekstu": "Text styles",
        "Szablon": "Template",
        "Szablon aktywny": "Template active",
        "Szablon nie został pobrany": "Template was not downloaded",
        "Szablon nie został usunięty": "Template was not deleted",
        "Szablon nie został zapisany": "Template was not saved",
        "Szablon został usunięty": "Template was deleted",
        "Szablon został zapisany": "Template was saved",
        "Szerokość": "Width",
        "Szerokość ekranu (px)": "Screen width (px)",
        "Szerokość w pikselach": "Width in pixels",
        "Szukaj elementu": "Search for an element",
        "Szukaj elementu…": "Search for an element…",
        "Szukaj w bibliotece": "Search library",
        "Szukaj w bibliotece…": "Search library…",
        "Tablet": "Tablet",
        "Target": "Target",
        "Tej operacji nie można cofnąć.": "This operation cannot be undone.",
        "Tekst": "Text",
        "Tekst alternatywny": "Alternative text",
        "Telefon": "Phone",
        "Tło": "Background",
        "Tłumaczenie": "Translation",
        "Transformacja": "Transform",
        "Tryb kreatora": "Builder mode",
        "Tryb układu": "Layout mode",
        "Twój adres email": "Your email address",
        "Twoje imie": "Your first name",
        "Typ": "Type",
        "Typ listy": "List type",
        "Typ nagłówka": "Header type",
        "Typ przycisku": "Button type",
        "Tytuł": "Title",
        "Tytuł dla open graph": "Open Graph title",
        "Tytuł strony": "Page title",
        "Układ": "Layout",
        "Ułóż sekcje i bloki w kreatorze stron": "Arrange sections and blocks in the page builder",
        "Ułóż sekcje i bloki w kreatorze stron.": "Arrange sections and blocks in the page builder.",
        "Ułożenie elementów": "Item arrangement",
        "Ułożenie elementów według głównej osi": "Arrange items along the main axis",
        "Ułożenie elementów według osi poprzecznej": "Arrange items along the cross axis",
        "Urządzenia": "Devices",
        "Urządzenie podglądu": "Preview device",
        "Usuń": "Delete",
        "Usuń element": "delete element",
        "Usuń kolor": "delete color",
        "Usuń szablon": "delete template",
        "Usuń urządzenie": "delete device",
        "Usuń warstwę": "delete layer",
        "Usuń wymiar": "delete dimension",
        "Usuń zawartość": "delete content",
        "Usuń zawartość strony": "delete page content",
        "Usunąć ten szablon?": "Delete this template?",
        "Utwórz": "Create",
        "Użyj styli zgodnych z CSS3": "Use CSS3-compatible styles",
        "W pionie": "Vertical",
        "W poziomie": "Horizontal",
        "Warstwy": "Layers",
        "Wartość": "Value",
        "Wartość koloru jest wymagana": "Color value is required",
        "Wartość w pikselach": "Value in pixels",
        "Wczytywanie biblioteki": "Loading library",
        "Wczytywanie szablonów": "Loading templates",
        "Wewnętrzny": "Internal",
        "Widget": "Widget",
        "Widget nie został usunięty": "Widget was not deleted",
        "Widget został usunięty": "Widget was deleted",
        "Widget został zaimportowany": "Widget was imported",
        "Widget został zaktualizowany": "Widget was updated",
        "Widget został zapisany": "Widget was saved",
        "Widoczność": "Visibility",
        "Wielka litera": "Uppercase",
        "Wiersz": "Row",
        "Wiersze": "Rows",
        "Włącz pełny ekran": "Enable full screen",
        "Własne": "Custom",
        "Własne polecenie": "Custom command",
        "Własny kod CSS": "Custom CSS code",
        "Własny kod HTML": "Custom HTML code",
        "Własny kod JavaScript": "Custom JavaScript code",
        "Własny kod React": "Custom React code",
        "Własny kod Vue": "Custom Vue code",
        "Własny widget": "Custom widget",
        "Wpisywanie tekstu": "Typing text",
        "Wpisz polecenie": "Enter command",
        "Wpisz tutaj cytat": "Enter quote here",
        "Wpisz tutaj swój nagłówek": "Enter your heading here",
        "Wpisz tutaj tekst": "Enter text here",
        "Wprowadź modyfikację": "Enter modification",
        "Wrapper": "Wrapper",
        "Wróć do edycji": "Back to edit",
        "Wszystkie sekcje i bloki zostaną usunięte z płótna.": "All sections and blocks will be removed from the canvas.",
        "Wszystko": "All",
        "Wybierz czcionki": "Select fonts",
        "Wybierz kolor": "Select color",
        "Wybierz opcję": "Select option",
        "Wycentrowanie": "Centering",
        "Wycisz film": "Mute video",
        "Wyczyść": "Clear",
        "Wyczyść formularz": "Clear form",
        "Wyczyść właściwość": "Clear property",
        "Wyczyścić całą stronę?": "Clear entire page?",
        "Wyczyszczenie formularza formularza": "Clear form form",
        "Wygenerowany tekst": "Generated text",
        "Wygląd listy": "List appearance",
        "Wymagany": "Required",
        "Wymiary dokumentu": "Document dimensions",
        "Wymiary kanwy": "Canvas dimensions",
        "Wyrównanie do końca": "Align to end",
        "Wyrównanie do początku": "Align to start",
        "Wyrównanie tekstu": "Text alignment",
        "Wysokość": "Height",
        "Wysokość linii": "Line height",
        "Wysokość w pikselach": "Height in pixels",
        "Wyśrodkowanie": "Center alignment",
        "Wystąpił błąd podczas próby exportu strony.": "An error occurred while trying to export the page.",
        "Wystąpił błąd podczas próby exportu widgetu.": "An error occurred while trying to export the widget.",
        "Wystąpił błąd podczas próby importu strony.": "An error occurred while trying to import the page.",
        "Wystąpił błąd podczas próby importu widgetu.": "An error occurred while trying to import the widget.",
        "Wystąpił błąd podczas zapisywania kodu CSS": "An error occurred while saving CSS code",
        "Wystąpił błąd podczas zapisywania kodu HTML": "An error occurred while saving HTML code",
        "Wystąpił błąd podczas zapisywania kodu JavaScript": "An error occurred while saving JavaScript code",
        "Wystąpił błąd podczas zapisywania komponentu React": "An error occurred while saving the React component",
        "Wyświetl kod": "View code",
        "YouTube": "YouTube",
        "Zaawansowany": "Advanced",
        "Zablokuj": "Lock",
        "Zaktualizuj": "Update",
        "Zamień wymiary": "Swap dimensions",
        "Zamknij": "Close",
        "Zanikanie": "Fade",
        "Zaokgrąglenie rogów": "Rounded corners",
        "Zapętlaj": "Loop",
        "Zapisywanie formularza": "Saving form",
        "Zapisz": "Save",
        "Zapisz formularz": "Save form",
        "Zarządzaj urządzeniami": "Manage devices",
        "Zawartość gotowa do edycji": "Content ready to edit",
        "Zawartość jest gotowa do edycji.": "Content is ready to edit.",
        "Zawijaj": "Wrap",
        "Zawijanie elementow": "Wrapping elements",
        "Zaznacz komponent, aby edytować animacje.": "Select a component to edit animations.",
        "Zaznaczony": "Selected",
        "Zaznaczony tekst": "Selected text",
        "Zdjęcie": "Photo",
        "Zdjęcie dla open graph": "Open Graph image",
        "Zewnętrzny": "External",
        "Zmień nazwę": "Rename",
        "Zmień rozmiary": "Resize",
        "Zmień wymiary dokumentu": "Change document dimensions",
        "Zoom": "Zoom",
        "Zwykły przycisk": "Standard button"
    }
};
